export const MODEL_NAME_MAX_TOKEN_MAP = {
    "claude-sonnet-4-5": {
        displayName: "Claude Sonnet 4.5",
    },
    "claude-haiku-4-5": {
        displayName: "Claude Haiku 4.5",
    },
};
export const FILE_ACCEPT_FORMATS =
    ".pdf,.jpeg,.jpg,.png,.gif,.webp,.txt,.csv,.xls,.xlsx,.xlsm,.docx";
export const BID_QUICKSTART_FILE_ACCEPT_FORMATS = ".xlsx,.xls,.xlsm,.pdf,.docx";
